import { render, staticRenderFns } from "./SimpleProductFixedPanel.vue?vue&type=template&id=079527c2&scoped=true&"
import script from "./SimpleProductFixedPanel.vue?vue&type=script&lang=ts&"
export * from "./SimpleProductFixedPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleProductFixedPanel.vue?vue&type=style&index=0&id=079527c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079527c2",
  null
  
)

export default component.exports